// extracted by mini-css-extract-plugin
module.exports = {"layout":"src-containers-Rules-Main-styles___layout","sidebarHeading":"src-containers-Rules-Main-styles___sidebarHeading"};